import React from 'react';
import PropTypes from 'prop-types';
import Input from 'components/atoms/input';

const TextInput = ({ id, label, note, error, required }) => (
  <div className="input-wrapper">
    <Input id={id} label={label} markRequired={required} />
    {error && <div className="input-error">{error}</div>}
    {note && <div className="input-note">{note}</div>}
  </div>
);
TextInput.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  note: PropTypes.string,
  required: PropTypes.string,
  error: PropTypes.string,
};

export default TextInput;
